'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Settings = require('./components/Settings.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Settings).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/settings/index.js
// module id = 926
// module chunks = 0